module.exports = __webpack_public_path__ + "media/logo/logo_mixi-85b50a0b.png";